/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { onGetcms } from "../../Store/Slices/cmsSlice";
import { useNavigate, useParams } from "react-router-dom";

import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import Loader from "../../Components/Loader/Loader";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { trackEvent } from "../../Components/Utility/Utility";
// import HTMLRender from "../../Components/HTMLRender";
const CmsPage = () => {
  const PageName = useParams();
  const dispatch = useDispatch();
  const translation = getTranslationData();
  const isLoading = useSelector((state) => state?.cmsReducer?.isLoading);
  const getcmsData = useSelector((state) => state?.cmsReducer.getcms);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    dispatch(onGetcms());
  }, []);
  const FilteredData =
    Array.isArray(getcmsData) &&
    getcmsData.filter((item) => item.title === PageName.pagetype);
  const FooterData = [];


  for (let i = 0; i < FilteredData.length; i++) {
    FooterData.push(FilteredData[0]);
  }
  const navigate = useNavigate();

  useEffect(() => {
    document.querySelectorAll('*').forEach(el => {
      if (el.scrollHeight > el.clientHeight) {
        el.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
    trackEvent("page_browse",
      {

        page_title: PageName.pagetype,
        page_url: window.location.href,

      });
  }, [PageName.pagetype])

  return (
    <>
      <ScrollToTop />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="terms-bg">
            <div className="terms-container">
              <div className="terms-header-wrapper">
                {!isMobile && (
                  <button className="back-button">
                    <i className="fas fa-angle-left"></i>
                    <span className="terms-pl" onClick={() => navigate(-1)}>
                      {translation?.back}
                    </span>
                  </button>
                )}
                <h2 className="terms-title">
                  {FooterData[0]?.shortDescription}
                </h2>
              </div>

              <div className="terms-content mt-2">
                <div
                  dangerouslySetInnerHTML={{
                    __html: FooterData[0]?.longDescription,
                  }}
                ></div>
                {/* <HTMLRender htmlContent={FooterData[0]?.longDescription} />*/}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default CmsPage;
/* eslint-enable react-hooks/exhaustive-deps */
